var render = function () {
  var _vm$leftRound, _vm$leftRound$vennDia, _vm$leftRound$vennDia2, _vm$leftRound2, _vm$centerRound, _vm$centerRound$vennD, _vm$centerRound$vennD2, _vm$centerRound2, _vm$rightRound, _vm$rightRound$vennDi, _vm$rightRound$vennDi2, _vm$rightRound2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('div', {
    staticClass: "steps-container venn-diagram-container",
    class: {
      isMobile: _vm.isMobile
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    class: {
      scaled: true,
      'chromeos-scale': _vm.isChromeOS,
      'mobile-scale': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "venn-diagram-circles-container"
  }, [_c('svg', {
    attrs: {
      "id": "venn-diagram-circles",
      "height": "460px",
      "width": "980px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.vennDiagramSVG)
    }
  })]), _c('article', {
    attrs: {
      "id": "paragraphs-container"
    }
  }, [_c('div', {
    staticClass: "left-paragraph-container step"
  }, [_c('div', {
    staticClass: "venn-image-left"
  }, [(_vm$leftRound = _vm.leftRound) !== null && _vm$leftRound !== void 0 && _vm$leftRound.vennDiagramOptionalImage ? _c('img', {
    attrs: {
      "alt": "Left image",
      "src": (_vm$leftRound$vennDia = _vm.leftRound.vennDiagramOptionalImage) === null || _vm$leftRound$vennDia === void 0 ? void 0 : (_vm$leftRound$vennDia2 = _vm$leftRound$vennDia.image) === null || _vm$leftRound$vennDia2 === void 0 ? void 0 : _vm$leftRound$vennDia2.src
    }
  }) : _vm._e()]), _vm._l((_vm$leftRound2 = _vm.leftRound) === null || _vm$leftRound2 === void 0 ? void 0 : _vm$leftRound2.steps, function (step, stepIndex) {
    return _c('div', {
      key: stepIndex,
      staticClass: "left-paragraph"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": stepIndex,
        "text": step.answer,
        "round-id": 0,
        "shouldBeCompletedStep": _vm.progress.roundIndex > 0 || _vm.progress.stepIndex > stepIndex
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "center-paragraph-container step"
  }, [_c('div', {
    staticClass: "venn-image-center"
  }, [(_vm$centerRound = _vm.centerRound) !== null && _vm$centerRound !== void 0 && _vm$centerRound.vennDiagramOptionalImage ? _c('img', {
    attrs: {
      "alt": "Center image",
      "src": (_vm$centerRound$vennD = _vm.centerRound.vennDiagramOptionalImage) === null || _vm$centerRound$vennD === void 0 ? void 0 : (_vm$centerRound$vennD2 = _vm$centerRound$vennD.image) === null || _vm$centerRound$vennD2 === void 0 ? void 0 : _vm$centerRound$vennD2.src
    }
  }) : _vm._e()]), _vm._l((_vm$centerRound2 = _vm.centerRound) === null || _vm$centerRound2 === void 0 ? void 0 : _vm$centerRound2.steps, function (step, stepIndex) {
    return _c('div', {
      key: stepIndex,
      staticClass: "center-paragraph"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": stepIndex,
        "text": step.answer,
        "round-id": 2
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "right-paragraph-container step"
  }, [_c('div', {
    staticClass: "venn-image-right"
  }, [(_vm$rightRound = _vm.rightRound) !== null && _vm$rightRound !== void 0 && _vm$rightRound.vennDiagramOptionalImage ? _c('img', {
    attrs: {
      "alt": "Right image",
      "src": (_vm$rightRound$vennDi = _vm.rightRound.vennDiagramOptionalImage) === null || _vm$rightRound$vennDi === void 0 ? void 0 : (_vm$rightRound$vennDi2 = _vm$rightRound$vennDi.image) === null || _vm$rightRound$vennDi2 === void 0 ? void 0 : _vm$rightRound$vennDi2.src
    }
  }) : _vm._e()]), _vm._l((_vm$rightRound2 = _vm.rightRound) === null || _vm$rightRound2 === void 0 ? void 0 : _vm$rightRound2.steps, function (step, stepIndex) {
    return _c('div', {
      key: stepIndex,
      staticClass: "right-paragraph"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text-step": stepIndex,
        "text": step.answer,
        "round-id": 1,
        "shouldBeCompletedStep": _vm.progress.roundIndex > 1 || _vm.progress.stepIndex > stepIndex
      }
    })], 1);
  })], 2)])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }